(function (scope, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else scope.IWKitV2Cart = factory(scope.IWKitV2Config || {});
})(typeof window === 'undefined' ? globalThis : window, function createKitPolicy(config) {
  'use strict';
  var marker = 'ironwomen-kit-v2';
  var kit = config.kit || {};
  var single = config.single || {};
  var gifts = Array.isArray(config.gifts) ? config.gifts : [];
  var productId = String(config.productId || '10340651696226');
  var asId = function (value) { return value == null ? '' : String(value); };
  var validId = function (value) { return /^\d+$/.test(asId(value)); };
  var variantId = function (item) { return asId(item && (item.variant_id || item.id)); };
  var planId = function (item) { return asId(item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id); };
  var giftFor = function (item) { return gifts.find(function (gift) { return validId(gift.variantId) && variantId(item) === asId(gift.variantId); }); };
  var paidKind = function (item) {
    if (validId(kit.variantId) && variantId(item) === asId(kit.variantId)) return 'kit';
    if (validId(single.variantId) && variantId(item) === asId(single.variantId)) return 'single';
    return '';
  };
  var taggedGift = function (item) {
    return !!giftFor(item) && item.properties && item.properties._iw_v2_source === marker && item.properties._iw_v2_role === 'welcome-gift';
  };
  var ownedLine = function (item) { return !!paidKind(item) || taggedGift(item); };
  var containsV2 = function (cart) {
    return !!cart && Array.isArray(cart.items) && cart.items.some(function (item) {
      return ownedLine(item) || asId(item.product_id) === productId;
    });
  };
  var ready = function () {
    var ids = [kit.variantId, single.variantId].concat(gifts.map(function (gift) { return gift.variantId; }));
    return validId(kit.sellingPlanId) && validId(single.sellingPlanId) && gifts.length === 2 &&
      ids.every(validId) && new Set(ids.map(asId)).size === 4 && kit.unitCents === 9990 && single.unitCents === 2990;
  };
  var reject = function (message) { return { ok: false, message: message }; };
  var mixedMessage = 'This routine needs a separate checkout from the other offer in your cart. Your items are still saved. Please check out the other items first, or remove them from this cart.';
  function inspect(cart) {
    if (!containsV2(cart)) return null;
    if (!ready()) return reject('This routine is not ready for checkout yet. Please try again shortly.');
    if (cart.items.some(function (item) { return !ownedLine(item); })) return reject(mixedMessage);
    if (cart.currency !== 'USD') return reject('This routine is currently priced in USD. Please select USD before checking out.');
    var paid = cart.items.filter(function (item) { return !!paidKind(item); });
    var quantity = paid[0] && Number(paid[0].quantity);
    if (paid.length !== 1 || !Number.isSafeInteger(quantity) || quantity < 1) return reject('Please choose one routine type for this checkout. You can change your selection on the product page.');
    var kind = paidKind(paid[0]);
    var offer = kind === 'kit' ? kit : single;
    if (planId(paid[0]) !== asId(offer.sellingPlanId)) return reject('We could not confirm the 28-day subscription. Please remove this routine and add it again from the product page.');
    if (Number(paid[0].original_price) !== offer.unitCents || Number(paid[0].final_line_price) !== offer.unitCents * quantity) return reject('The routine price has changed. Please refresh your cart before checking out.');
    var giftLines = cart.items.filter(taggedGift);
    if (kind === 'single' && giftLines.length) return reject('The welcome gifts belong to the complete kit. Please refresh your cart to update your selection.');
    var seen = new Set();
    for (var i = 0; i < giftLines.length; i++) {
      var line = giftLines[i];
      var id = variantId(line);
      if (seen.has(id) || Number(line.quantity) !== 1 || planId(line) || Number(line.final_line_price) !== 0) return reject('We could not confirm your free welcome gifts. Please remove the kit and add it again before checking out.');
      seen.add(id);
    }
    return { ok: true, kind: kind, quantity: quantity, amountCents: offer.unitCents * quantity };
  }
  function orphanGiftUpdates(cart) {
    var updates = {};
    if (!ready() || !cart || !Array.isArray(cart.items)) return updates;
    if (cart.items.some(function (item) { return !ownedLine(item); })) return updates;
    if (cart.items.some(function (item) { return paidKind(item) === 'kit' && Number(item.quantity) > 0; })) return updates;
    cart.items.forEach(function (item) {
      if (taggedGift(item) && typeof item.key === 'string' && item.key) updates[item.key] = 0;
    });
    return updates;
  }
  function replacementUpdates(cart) {
    var updates = {};
    if (!ready() || !cart || !Array.isArray(cart.items)) return updates;
    cart.items.forEach(function (item) {
      if (ownedLine(item) && typeof item.key === 'string' && item.key) updates[item.key] = 0;
    });
    return updates;
  }
  function itemsFor(kind) {
    if (!ready() || (kind !== 'kit' && kind !== 'single')) throw new Error('The routine is not ready yet.');
    var offer = kind === 'kit' ? kit : single;
    var items = [{ id: asId(offer.variantId), quantity: 1, selling_plan: asId(offer.sellingPlanId), properties: { _iw_v2_source: marker, _iw_v2_offer: kind } }];
    if (kind === 'kit') gifts.forEach(function (gift) {
      items.push({ id: asId(gift.variantId), quantity: 1, properties: { _iw_v2_source: marker, _iw_v2_offer: 'kit', _iw_v2_role: 'welcome-gift' } });
    });
    return items;
  }
  return { ready: ready, containsV2: containsV2, ownsLine: ownedLine, inspect: inspect, itemsFor: itemsFor, orphanGiftUpdates: orphanGiftUpdates, replacementUpdates: replacementUpdates, mixedMessage: mixedMessage };
});
